export enum ZendeskChatTag {
  AccountPortal = 'account_portal',
  CancelIntent = 'cancel_intent',
}
